// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import Ajv from "ajv";

import * as serviceSelectors from "@modules/service/selectors";
import actionCreator from "@modules/service/actionCreator";
import { Button, Col, Row } from "@components";
import type { StepProps } from "@components";
import { AlertServiceLengthForm } from "@modules/service/components";
import type { Alert } from "@modules/service/reducer/alerts/types";

type StepData = $Exact<{
  serviceLength: ?Object,
}>;

type OwnProps = $Exact<{
  editing: boolean,
}>;

type PropsFromState = $Exact<{
  schema: ?Object,
  draft: ?Alert,
}>;

type PropsFromDispatch = $Exact<{
  setDraft: typeof actionCreator.SetAlertDraft,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class StepServiceLength extends React.Component<Props> {
  validate: *;

  componentDidMount() {
    this.validate = new Ajv().compile(this.schema);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.schema && prevProps.schema !== this.schema) {
      this.validate = new Ajv().compile(this.schema);
    }
  }

  get data(): StepData {
    return { serviceLength: (this.props.draft || {}).content.serviceLength || null };
  }

  get schema() {
    return { serviceLength: (this.props.schema || {}).properties.serviceLength };
  }

  isValid = (data: Object) => {
    if (!this.validate) {
      return false;
    }

    const isValid = data.serviceLength === null || this.validate(data.serviceLength);
    if (!isValid) {
      console.warn("isValid errors", this.validate.errors, data.serviceLength, this.schema);
    }

    return isValid;
  };

  handleSubmit = () => {
    if (this.props.handleSubmit) {
      this.props.setDraft({
        ...this.props.draft,
        content: {
          ...this.props.draft?.content,
          ...this.data,
        },
      });
      this.props.handleSubmit({}, true);
    }
  };

  updateServiceLength = (formData: Object) => {
    this.props.setDraft({
      ...this.props.draft,
      content: {
        ...this.props.draft?.content,
        ...{ serviceLength: formData },
      },
    });
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <React.Fragment>
        <Row className="w-100 d-flex py-3">
          <Col>
            {this.schema ? (
              <AlertServiceLengthForm
                data={this.data.serviceLength}
                schema={this.schema.serviceLength}
                onChange={this.updateServiceLength}
                onSubmit={this.handleSubmit}
              />
            ) : null}
          </Col>
        </Row>
        {this.props.editing ? null : (
          <div className="w-100 d-flex justify-content-end mt-5 mb-3">
            <Button
              materialIcon="fast_forward"
              onClick={this.handleSubmit}
              disabled={!this.isValid(this.data)}
            >
              {this.props.t("NEXT")}
            </Button>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    schema: serviceSelectors.getAlertSchema(state),
    draft: serviceSelectors.getAlertDraft(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setDraft: actionCreator.SetAlertDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(StepServiceLength);
